import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@bcc/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { setDeleteDraftDialogTestId } from "./delete-draft-dialog.utils";

export interface DeleteDraftDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  draftTitle?: string;
  onConfirm: () => void;
  isPending?: boolean;
}

export const DeleteDraftDialog = ({ open, onOpenChange, draftTitle, onConfirm, isPending = false }: DeleteDraftDialogProps) => {
  const { t } = useTranslation();
  const testIds = setDeleteDraftDialogTestId();

  const handleConfirm = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      // Prevent Radix from auto-closing so we can show a loading state while the
      // mutation is in flight. The parent controls `open`.
      event.preventDefault();
      onConfirm();
    },
    [onConfirm]
  );

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent testId={testIds.content}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={testIds.title}>{t("ssRoaster.drafts.deleteDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription data-testid={testIds.body}>
            {t("ssRoaster.drafts.deleteDialog.body", { title: draftTitle })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel testId={testIds.cancel} disabled={isPending}>
            {t("ssRoaster.drafts.deleteDialog.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction testId={testIds.confirm} onClick={handleConfirm} disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
            {t("ssRoaster.drafts.deleteDialog.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
